import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { NetworkView } from "./network";
import type { OnPanelAction } from "@/shared/plugin-panel-host";
import { setPendingRdpTarget, setPendingWebTarget, activatePanel } from "@/shared/network-actions";

/**
 * Panel « Scanner de services » : test ping + ports TCP d'un hôte, avec actions
 * rapides (RDP, Web) vers les panels dédiés quand un port est ouvert.
 *
 * Le handler onAction est le pont SolidJS↔vanilla : le panel network distant
 * (vue `scan`) l'appelle, on y dépose la cible dans les signals partagés puis on
 * navigue vers le panel cible (RdpPanel / LanBrowser), qui lit la cible au montage.
 */
const onAction: OnPanelAction = (type, payload) => {
  if (type === "rdp") {
    setPendingRdpTarget({ host: payload.host, port: payload.port });
    activatePanel("panel:rdp");
  } else if (type === "web") {
    setPendingWebTarget({
      host: payload.host,
      port: payload.port,
      url: payload.url || `http://${payload.host}${payload.port && payload.port !== 80 ? ":" + payload.port : ""}`,
    });
    activatePanel("panel:lanbrowser");
  } else if (type === "smb") {
    activatePanel("panel:smb");
  } else if (type === "files") {
    activatePanel("panel:files");
  } else if (type === "ssh") {
    activatePanel("panel:ssh");
  }
};

const NetworkScanPanel: Component = () => <NetworkView title="Scanner de services" view="scan" onAction={onAction} />;

registerPanel("network-scan", NetworkScanPanel);
export default NetworkScanPanel;
